import React from 'react'

const Bannerload = () => {
  return (
    <div className='h-48 w-full animate-pulse rounded-lg bg-gray-100'></div>
  )
}

export default Bannerload;


